export default __webpack_public_path__ + "static/analytics-0c07ab9d89290b4732d15fe19eb070c1.png";